import { defineComponent as _defineComponent } from 'vue'
import {computed} from 'vue';
import User from '@/models/user/User';
import PersonAvatar from '@/components/commons/PersonAvatar.vue';
import BaseBadge from '@/components/badges/base/BaseBadge.vue';
import {LanguageCountryCodes, Languages} from '@/commons/enums/Languages';
import {useCountryFlag} from '@/composables/useCountryFlags';
import {useInstance} from '@/composables/useInstance';
import {AutomationTestsIds} from '@/env/AutomationTests/ids/AutomationTestsIds';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBadge',
  props: {
    user: { default: null },
    showId: { type: Boolean, default: false },
    showLogin: { type: Boolean, default: false },
    right: { type: Boolean, default: false },
    showLanguageFlags: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { user: Nullable<User>, showId: boolean, showLogin: boolean, right: boolean, showLanguageFlags: boolean };



const {getFlagEmoji} = useCountryFlag();
const {$i18n} = useInstance();
const t = $i18n.OrganisationId;

const organisationName = computed<Nullable<string>>(() =>
  props.user?.organisationId ? t[props.user.organisationId] : null
);

const spokenLanguageFlags = computed(() => {
  const user = props.user;
  if (!props.showLanguageFlags || !user) {
    return [];
  }

  const canSpeak: Record<Languages, boolean | undefined> = {
    [Languages.ENGLISH]: user.canSpeakEnglish ?? user.privileges?.canSpeak?.[Languages.ENGLISH],
    [Languages.GERMAN]: user.canSpeakGerman ?? user.privileges?.canSpeak?.[Languages.GERMAN],
    [Languages.UKRAINIAN]: user.canSpeakUkrainian ?? user.privileges?.canSpeak?.[Languages.UKRAINIAN],
  };

  return (Object.values(Languages) as Languages[])
    .filter(language => canSpeak[language])
    .map(language => getFlagEmoji(LanguageCountryCodes[language]));
});

return { __sfc: true,props, getFlagEmoji, $i18n, t, organisationName, spokenLanguageFlags, PersonAvatar, BaseBadge, AutomationTestsIds }
}

})